import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import Tab from "../../../../../common/tabs/Tab";
import Tabs from "../../../../../common/tabs/Tabs";
import { GET } from "../../../../../utils/fetchUtil";
import JournalInfo from "./JournalInfo";
import JournalLetters from "./JournalLetters";
import JournalTimeline from "./JournalTimeline";
import JournalAttachments from "./JournalAttachments";
import JournalFinances from "./JournalFinances";
import { MessageContext } from "../../../../../common/message";

function Journal({ uid, id, rows }) {
  const [activeTab, setActiveTab] = useState(1);
  const [doc, setDoc] = useState([]);
  const [work, setWork] = useState({});
  const [setLetters] = useState([]);
  const [setAttachments] = useState([]);
  const [setFinances] = useState([]);
  const { t } = useTranslation();
  const message = useContext(MessageContext);
  useEffect(() => {
    GET(
      `/requests/${id}/submissions/${uid}/journal`,
      (journal) => {
        setDoc(journal.doc);
        setWork(journal.work);
      },
      (error) => {
        message.toggle({
          title: t("requests.reviewDocuments.action.save.error"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  }, [uid, id]);

  /* useEffect(() => {
    GET(
      `/requests/submissions/${id}`,
      (rows) => {
        setLetters(rows);
        setAttachments(rows);
        setFinances(rows);
      },
      (error) => {
        message.toggle({
          title: t("requests.reviewDocuments.action.save.error"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  }, [setLetters, setAttachments, setFinances, uid, id]); */

  return (
    <div className="content">
      <Tabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabsClassName={"mt-6 is-size-6"}
        scrollToSection={false}
      >
        <Tab
          label={t("requests.preview.journal.letters.tab")}
          render={() => <JournalLetters letters={rows} />}
        />
        <Tab
          label={t("requests.preview.journal.attachments.tab")}
          render={() => <JournalAttachments attachments={rows} />}
        />
        {/* <Tab
          label={t("requests.preview.journal.finances.tab")}
          render={() => <JournalFinances finances={rows} />}
        /> */}
        <Tab
          label={t("requests.preview.journal.timeline.tab")}
          render={() => <JournalTimeline work={work} />}
        />
        <Tab
          label={t("requests.preview.journal.info.tab")}
          render={() => <JournalInfo doc={doc} />}
        />
      </Tabs>
    </div>
  );
}
export default Journal;
